import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OpsSidebarComponent } from '../ops-sidebar/ops-sidebar.component';

@Component({
    selector: 'app-ops-bottombar',
    templateUrl: './ops-bottombar.component.html',
    styleUrls: ['./ops-bottombar.component.scss'],
    standalone: false
})
export class OpsBottombarComponent extends OpsSidebarComponent {
    @Input() sidebarExtends: boolean;
    @Output() onSidebarExtends = new EventEmitter();
}
